import { AppBar, Tab } from "@mui/material";
import { TabLargeStyle } from "assets/jss/common-styles";
import { AppBarTabs } from "components/AppTabs";
import MuiContainer from "components/MuiExtras/MuiContainer";
import * as React from "react";
import { useTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

export enum TabOptions { Participation, Knowledge, Insights }

interface IProps {
    currentTab: TabOptions;
    onTabChange: (tab: TabOptions) => void;
}

/////////////////////////////////////////////////////////////////////////////////////

export const UserAndGroupsTabs: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    return (
        <MuiContainer margin="dense">
            <AppBar position="static" color="primary"  >
                <AppBarTabs centered value={props.currentTab} onChange={(event: React.ChangeEvent<{}>, value: TabOptions) => props.onTabChange(value)}>
                    <Tab key={TabOptions.Participation} value={TabOptions.Participation} label={t("Views.Dashboards.UserAndGroups.Tabs.Participation")} style={TabLargeStyle} />
                    <Tab key={TabOptions.Knowledge} value={TabOptions.Knowledge} label={t("Views.Dashboards.UserAndGroups.Tabs.Knowledge")} style={TabLargeStyle} />
                </AppBarTabs>
            </AppBar>
        </MuiContainer>
    );
};
